import React from 'react';
import moment from 'moment';
import {Card} from '../Card';
import {Text} from '../Text';
import {Button} from '../Button';
import TagPreview from '../TagPreview';

export function TagCard(props) {
  
  let name = props.name || "";
  if(props.product && !name) {
    name = props.product.title;
  }
  
  let size = "";
  if(props.variant) {
    size = props.variant.tile;
  }
  
  
  
  return (
    <Card style={{marginBottom:16, display:'flex', flexDirection:'row', alignItems:'flex-start', ...props.style}}>
      <Button onClick={props.onClick} to={!props.onClick ? `/tags/${props.id}` : null} style={{flex:1, display:'block', padding:"0 16px 0 0"}}>
        <Text block semibold color="#fa637d" style={{marginBottom:4}}>{name} {size ? `(${size})` : ""}</Text>
        <Text block small style={{marginBottom:12}}>
          Modified: {moment(props.dateModified).format("MMMM DD")}
        </Text>
      </Button>
      <div style={{flex:'0 0 auto'}}>
        <TagPreview {...props} style={{width:80}}/>
      </div>
    </Card>
  );  
}